// extracted by mini-css-extract-plugin
export var activityContainer = "_n0-0";
export var typingIndicatorContainer = "_n0-1";
export var typingIndicatorDot = "_n0-2";
export var wave = "_n0-3";